<template>
  <div
    class="operation-report-workflow-status flex flex-col items-center"
    :class="{ 'is-doing': isDoing, 'is-todo': isTodo }"
  >
    <div class="no-label aisea-text-24-400-dark-gray">{{ noLabel }}</div>
    <div class="header-label-check-circle flex flex-col items-center w-full">
      <div class="header-label aisea-text-16-400-dark-gray">
        {{ headerLabel }}
      </div>
      <div
        class="check-circle-wrapper flex flex-col justify-center items-center flex-1 w-full"
      >
        <div class="check-circle flex flex-col justify-center items-center ">
          <check-icon />
        </div>
        <div
          v-show="showProgressBar"
          class="status-progress-bar relative flex justify-center items-center order-first m-0"
        >
          <span class="progress-bar-border w-full"></span>
        </div>
      </div>
    </div>
    <div class="footer-label aisea-text-14-400-dark-gray">
      {{ footerLabel }}
    </div>
  </div>
</template>

<script>
import CheckIcon from "@/views/enterprise/addon/operation/components/icons/CheckIcon";

export default {
  name: "OperationReportWorkflowStatus",
  components: { CheckIcon },
  props: {
    noLabel: {
      type: String,
      default: "",
    },
    headerLabel: {
      type: String,
      default: "",
    },
    footerLabel: {
      type: String,
      default: "",
    },
    isDone: {
      type: Boolean,
      default: false,
    },
    isDoing: {
      type: Boolean,
      default: false,
    },
    isTodo: {
      type: Boolean,
      default: false,
    },
    showProgressBar: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.operation-report-workflow-status {
  --circle-size: 26px;
  --circle-z-index: 1;
  --progress-bar-offset-right: 50%;
  --left-spacing: 7px;
  --right-spacing: 7px;

  row-gap: 8px;
  width: 120px;
  height: 96px;
  line-height: 1;

  .header-label-check-circle {
    row-gap: 3px;
  }

  .check-circle {
    width: var(--circle-size);
    height: var(--circle-size);
    border-radius: 50%;
    background-color: $aisea-blue;
    border-color: $aisea-blue;
    border-style: solid;
    border-width: 3px;

    z-index: var(--circle-z-index);
  }

  .status-progress-bar {
    top: calc(var(--circle-size) / 2);
    right: var(--progress-bar-offset-right);

    width: calc(
      100% - (var(--circle-size)) - var(--left-spacing) - var(--right-spacing)
    ); // プログレスバーとステータスの間のスペースを調整

    height: 0; // プログレスバーの高さがステータスのコンポーネントの高さに影響しないようにする

    .progress-bar-border {
      border-top: 2px solid $aisea-blue;
    }
  }

  &.is-doing {
    .check-circle {
      background-color: transparent;
      border-style: solid;
      border-width: 3px;
    }
    .status-progress-bar {
      .progress-bar-border {
        border: none;
        background-image: repeating-linear-gradient(
          to right,
          $aisea-blue 0,
          $aisea-blue 2px,
          transparent 2px,
          transparent 6px,
          $aisea-blue 6px,
          $aisea-blue 8px
        );
        height: 2px;
      }
    }
  }

  &.is-todo {
    * {
      color: $aisea-mouse-gray;
    }
    .check-circle {
      background-color: transparent;
      border-color: $aisea-mouse-gray;
      border-style: solid;
      border-width: 3px;
    }
    ::v-deep .check-icon {
      path {
        fill: transparent;
      }
    }
    .status-progress-bar {
      .progress-bar-border {
        border-color: $aisea-mouse-gray;
      }
    }
  }
}
</style>
